import { InputPicker } from 'rsuite';
import api from '../../../../api';
import styles from './ManufacturerSearch.module.css';
import { useEffect, useState } from 'react';
import CreateManufacturerModal from './Components/CreateManufacturerModal/CreateManufacturerModal';
import { useCreateManufacturerModal } from './Components/CreateManufacturerModal/useCreateManufacturerModal';

function ManufacturerSearch({
	onManufacturerChangeName,
	onCreate,
	defaultManufacturerId,
	defaultManufacturerName,
	readonly,
	inputWidth,
}) {
	let [manufacturersOptions, setManufacturersOptions] = useState([]);
	let [manufacturerId, setManufacturersId] = useState(undefined);
	let [manufacturerName, setManufacturerName] = useState('');
	let [latestSearchRequest, setLatestSearchRequest] = useState(null);

	const { showCreateManufacturerModal } = useCreateManufacturerModal();

	let getManufacturers = async (search) => {
		const filter = {};
		const activePage = 1;
		const itemsPerPage = 10;

		const searchValues = search ? { name: search } : undefined;

		let { manufacturers } = await api.manufacturer.getAll(filter, { activePage, itemsPerPage }, searchValues);

		let manufacturersOptions = manufacturers.map((item) => ({ label: `${item.name} `, value: item.name }));
		setManufacturersOptions(manufacturersOptions);
	};

	let searchInputHandler = (searchValues) => {
		if (latestSearchRequest) {
			clearTimeout(latestSearchRequest);
		}

		latestSearchRequest = setTimeout(() => {
			getManufacturers(searchValues);
		}, 500);

		setLatestSearchRequest(latestSearchRequest);
	};

	let manufacturerHandler = (v) => {
		// setManufacturersId(v);
		// onManufactureChange(v);
		setManufacturerName(v);
		onManufacturerChangeName(v);
	};

	let newManufacturerHandler = (id, name) => {
		setManufacturersOptions((manufacturersOptions) => [
			...manufacturersOptions,
			{ label: `${name}`, value: `${name}` },
		]);
		console.log(manufacturersOptions);
		// setManufacturersId(id);
		// onManufactureChange(id);
		setManufacturerName(name);
		onManufacturerChangeName(name);
	};

	const downloadManufacturer = async () => {
		const manufacturer = await api.manufacturer.getById(defaultManufacturerId);

		if (!manufacturer) return;

		let maufacturersOptions = [manufacturer].map((item) => ({ label: `${item.name} `, value: item.name }));

		setManufacturersOptions(maufacturersOptions);
		setManufacturerName(manufacturer.name);
		//setManufacturersId(maufacturer._id);
	};

	useEffect(() => {
		if (!defaultManufacturerName && defaultManufacturerId) {
			downloadManufacturer();
		} else {
			if (defaultManufacturerName != '' && defaultManufacturerName != undefined) {
				setManufacturersOptions({
					label: `${defaultManufacturerName} `,
					value: `${defaultManufacturerName != undefined ? defaultManufacturerName : ''}`,
				});
				//getManufacturers(defaultManufacturerName);
				setManufacturerName(defaultManufacturerName);
			} else {
				getManufacturers();
			}
		}
		//getManufacturers();
	}, []);

	const styleWidth = inputWidth !== undefined ? inputWidth : 250;

	return (
		<>
			<InputPicker
				readOnly={readonly}
				creatable
				onCreate={showCreateManufacturerModal}
				cleanable={false}
				value={manufacturerName}
				onChange={manufacturerHandler}
				onSearch={searchInputHandler}
				data={manufacturersOptions}
				style={{ width: styleWidth }}
				placeholder={'Select manufacturer'}
			/>

			<CreateManufacturerModal newManufacturerHandler={newManufacturerHandler} />
		</>
	);
}

export default ManufacturerSearch;
